import { tailwindVariants } from '@air/utils-tailwind';

/** Border, fill, and text for each tone. Layout stays on the shape components. */
export const announcementTone = tailwindVariants({
  base: 'border',
  variants: {
    tone: {
      error: 'ads:border-error border-red-6 ads:bg-error-subtle bg-red-2 ads:text-error text-red-12',
      info: 'ads:border-primary-subtle border-blue-6 ads:bg-primary-subtle bg-blue-2 ads:text-primary text-blue-12',
      neutral: 'ads:border-strong border-gray-6 ads:bg-raised bg-gray-2 ads:text-primary text-gray-12',
      warning: 'ads:border-warning border-yellow-6 ads:bg-warning bg-yellow-2 ads:text-warning text-yellow-12',
    },
  },
});
